import API_URLS from '../../constants/api-urls';
import { FOLDER_DIRECTORIES } from '../../constants/folder';
import axios from '../../utils/axios';

type AddSingleMaterialArgs = {
    folderIds: number[];
    folder_type: FOLDER_DIRECTORIES;
    materialId: number;
};

export const addSingleMaterial = ({ materialId, folderIds, folder_type }: AddSingleMaterialArgs) =>
    axios.post(`${API_URLS.FOLDERS.MATERIALS}/${materialId}/sync`, {
        folder_ids: folderIds,
        folder_type
    });
